import { defineStore } from 'pinia'
import socket from '@/utils/webSocket'
// eslint-disable-next-line import/extensions
import pako from 'pako/dist/pako.min.js'
import { usePriceStore } from '@/store'
import {isH5, isMp} from "@/utils/platform.ts";

export const useSocket = defineStore('socket', () => {
  const newSocket = ref<any>(null)

  const messageFn = (message) => {
    if (message) {
      const decodedData = uni.base64ToArrayBuffer(message)
      try {
        const info = pako.ungzip(decodedData, { to: 'string' }) // 解压成字符串
        const resBody = JSON.parse(info || '{}')
        const usePrice = usePriceStore()
        if (resBody) {
          usePrice.setOpen(resBody.trade)
          usePrice.setPriceId(resBody.id)
          usePrice.setPrice(resBody)
        }
      } catch (error) {
        console.error('Decompression error: ', error)
      }
    }
  }

  // 连接
  function connect() {
    // 请求基准地址
    let baseUrl = import.meta.env.VITE_WS_URL
    // 小程序端环境区分
    if (isMp) {
      const {
        miniProgram: { envVersion },
      } = uni.getAccountInfoSync()

      switch (envVersion) {
        case 'develop':
          baseUrl = 'wss://api.beijingzxj.com/market/websocket'
          break
        case 'trial':
          baseUrl = 'wss://api.beijingzxj.com/market/websocket'
          break
        case 'release':
          baseUrl = 'wss://api.beijingzxj.com/market/websocket'
          break
      }
    }
    newSocket.value = socket(baseUrl, 1000, (message) => {
      messageFn(message)
    })
  }

  // 断开连接
  function disconnect() {
    if (newSocket.value) {
      newSocket.value.close()
    }
  }

  return {
    connect,
    disconnect,
    newSocket,
  }
})
